import { createGlobalStyle } from 'styled-components'
import {
  defaultThemeColors,
  successColor,
  dangerColor,
  warningColor,
} from './defaultTheme'

export default createGlobalStyle`
  @font-face {
    font-family: 'Cera Pro';
    src: url('/fonts/CeraPro-Light.woff2') format('woff2'),
      url('/fonts/CeraPro-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('/fonts/CeraPro-Regular.woff2') format('woff2'),
      url('/fonts/CeraPro-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('/fonts/CeraPro-Medium.woff2') format('woff2'),
      url('/fonts/CeraPro-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('/fonts/CeraPro-Bold.woff2') format('woff2'),
      url('/fonts/CeraPro-Bold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Cera Pro';
    src: url('/fonts/CeraPro-Black.woff2') format('woff2'),
      url('/fonts/CeraPro-Black.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${props => props?.theme?.text || defaultThemeColors.text};
   
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  
  html, body {
    background-color: ${props => props?.theme?.background2 || defaultThemeColors.background2}; 
  }
  
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Cera Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  }

  :root {
    --audiency-primary-color: ${props => props?.theme?.primary || defaultThemeColors.primary};
    --audiency-secondary-color: ${props => props?.theme?.secondary || defaultThemeColors.secondary};
    --audiency-red-color: ${dangerColor};
    --audiency-green-color: ${successColor};
    --audiency-alert-color: ${warningColor};
    --shadow: 0 1px 3px 0 rgb(0 0 0 / 15%), 0 1px 1px 0 rgb(0 0 0 / 1%), 0 2px 1px -1px rgb(0 0 0 / 1%);
    --elevation: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
    --global-padding: 0px 10px;
    --audiency-font: 'Open Sans', sans-serif;
    --audiency-text-color: ${props => props?.theme?.text || defaultThemeColors.text};
  }

  body::-webkit-scrollbar-track,
  .main-scroll::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px ${defaultThemeColors.primary};
    box-shadow: inset 0 0 6px ${defaultThemeColors.primary};
    border-radius: 10px;
    background-color: #F5F0FF;
  }

  body::-webkit-scrollbar,
  .main-scroll::-webkit-scrollbar {
    width: 10px;
    background-color: #F5F0FF;
  }

  body::-webkit-scrollbar-thumb,
  .main-scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px ${defaultThemeColors.primary};
    box-shadow: inset 0 0 6px ${defaultThemeColors.primary};
    background-color: ${defaultThemeColors.primary};
  }

  .minha-conta-controle-usuarios::-webkit-scrollbar-thumb {
    background-color: ${defaultThemeColors.primary};
  }

  body::-webkit-scrollbar,
  .main-scroll-invisible::-webkit-scrollbar {
    display: none;
  }

  body::-webkit-scrollbar-thumb,
  .main-scroll-invisible::-webkit-scrollbar-thumb {
    display: none;
  }


  .bg1 {
    background-color: aqua;
  }

  .bg2 {
    background-color: aquamarine;
  }

  .bg3 {
    background-color: yellow;
  }

  .bg4 {
    background-color: yellowgreen;
  }

  .main-content{
    min-height: 85vh;
  }

  .button {
    box-shadow: none;
  }
`
